import axios from "@/utils/request.js";
import qs from "qs"
// 新增/编辑 节目单 保存
const programAdd = (params) => axios({
  url: '/api/web-manager/live/program/add',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 用户 编辑 保存
const programEdit = (params) => axios({
  url: '/api/web-manager/live/program/edit',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 删除节目单 支持批量
const programDelete = (params) => axios({
  url: '/api/web-manager/live/program/delete',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 复制节目单 （ 天、周）
const programCopyProgram= (params) => axios({
  url: '/api/web-manager/live/program/copyProgram',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 复制虚拟节目单（天、周）
const programCopyVisualProgram= (params) => axios({
  url: '/api/web-manager/live/program/copyVisualProgram',
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  data: qs.stringify(params)
})
// 导出节目单  json 或者 exl
const programExportFileBlob= (params) => axios({
  url: "/api/web-manager/live/program/exportFile",
  method: "post",
  params,
  responseType: "blob",
})

// 导出节目单  json 或者 exl
const programExportFileText = (params) => axios({
  url: "/api/web-manager/live/program/exportFile",
  method: "post",
  params,
  responseType: "text",
})

// 节目单列表
const programPage = (params) => axios.get('/api/web-manager/live/program/page', {
  params
})
// 节目单列表  无token
const programPageNotoken = (params) => axios.get('/api/web-manager/live/program/page/notoken', {
  params
})
// 新增/编辑 虚拟直播节目 保存
const programVisual= (params) => axios({
  url: `/api/web-manager/live/program/visual/${params.liveTvId}`,
  method: 'post',
  data: params.list
})
export {
  programAdd,
  programEdit,
  programDelete,
  programCopyProgram,
  programCopyVisualProgram,
  programExportFileBlob,
  programExportFileText,
  programPage,
  programPageNotoken,
  programVisual,
}